import { QueryClient } from '@tanstack/react-query';

/** Shared TanStack Query client for the web app (provided at the App root). */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: Infinity, retry: false } },
});
